/* ═══════════════════════════════════════════════
   NATALEE SHOPIFY THEME — JavaScript v2
═══════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Cart API ── */
  window.NataleeCart = {
    async updateItem(key, qty) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      const cart = await res.json();
      window.NataleeCart.updateBadge(cart.item_count);
      return cart;
    },
    async addItem(id, qty) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty || 1 })
      });
      const item = await res.json();
      const cart = await fetch('/cart.js').then(r => r.json());
      window.NataleeCart.updateBadge(cart.item_count);
      return item;
    },
    updateBadge(n) {
      /* New header v2 badge */
      const badge = document.getElementById('ntHdBadge');
      if (badge) {
        badge.textContent = n;
        badge.classList.toggle('on', n > 0);
      }
      document.querySelectorAll('[data-nt-cart-count], .nt-hbar-badge').forEach(el => {
        el.textContent = n;
        el.classList.toggle('on', n > 0);
      });
      /* Legacy selectors (cart page, etc.) */
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = n;
        el.style.display = n > 0 ? 'flex' : 'none';
      });
      document.querySelectorAll('.cart-dot').forEach(dot => {
        dot.style.display = n > 0 ? 'block' : 'none';
      });
    },
    async getCount() {
      const cart = await fetch('/cart.js').then(r => r.json());
      window.NataleeCart.updateBadge(cart.item_count);
    }
  };

  /* ── Add to cart form handler ── */
  // Compatibility helper for the reusable Brand Header Bar cart link.
  window.NTCart = window.NTCart || {
    open() {
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }

      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger instanceof HTMLElement) {
        trigger.click();
        return true;
      }

      return false;
    },
    async refresh() {
      try {
        const cart = await fetch('/cart.js').then(r => r.json());
        window.NataleeCart.updateBadge(cart.item_count || 0);
        return cart;
      } catch (_error) {
        return null;
      }
    },
    updateBadge(n) {
      window.NataleeCart.updateBadge(n);
    }
  };

  document.addEventListener('cart:update', event => {
    if (event.detail?.data?.didError) return;

    const itemCount = event.detail?.resource?.item_count;
    if (typeof itemCount === 'number') {
      window.NataleeCart.updateBadge(itemCount);
    } else {
      window.NTCart.refresh();
    }
  });

  document.addEventListener('click', event => {
    if (event.defaultPrevented) return;

    const trigger = event.target instanceof Element ? event.target.closest('[data-nt-cart-trigger]') : null;
    if (!trigger) return;

    if (window.NTCart.open()) {
      event.preventDefault();
      window.NTCart.refresh();
    }
  });

  // Legacy Natalee product forms only; Horizon product forms are left untouched.
  function initAddToCart() {
    document.querySelectorAll('.nt-add-to-cart-form').forEach(form => {
      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        const btn = form.querySelector('[type="submit"]');
        const id = form.querySelector('[name="id"]').value;
        const qty = parseInt(form.querySelector('[name="quantity"]')?.value || 1);
        if (!id) return;
        const original = btn.textContent;
        btn.textContent = 'Dodawanie…';
        btn.disabled = true;
        try {
          await window.NataleeCart.addItem(id, qty);
          btn.textContent = 'Dodano ✓';
          setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1800);
        } catch {
          btn.textContent = 'Błąd';
          setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1800);
        }
      });
    });
  }

  /* ── Cart quantity buttons ── */
  function initCartQty() {
    document.querySelectorAll('.nt-qty-minus, .nt-qty-plus').forEach(btn => {
      btn.addEventListener('click', async function () {
        const input = this.closest('.nt-cart-qty').querySelector('input');
        const key = input.dataset.key;
        let qty = parseInt(input.value) + (this.classList.contains('nt-qty-plus') ? 1 : -1);
        if (qty < 0) qty = 0;
        input.value = qty;
        await window.NataleeCart.updateItem(key, qty);
        if (qty === 0) location.reload();
      });
    });
  }

  /* ── Size selector ── */
  function initSizeSelector() {
    document.querySelectorAll('.nt-size-grid, .size-opts').forEach(grid => {
      grid.querySelectorAll('.nt-size-btn:not(.unavail), .size-opt:not(.sold)').forEach(btn => {
        btn.addEventListener('click', function () {
          grid.querySelectorAll('.nt-size-btn, .size-opt').forEach(b => b.classList.remove('selected', 'active'));
          this.classList.add('selected', 'active');
          const variantId = this.dataset.variantId;
          if (variantId) {
            const idInput = document.querySelector('[name="id"]');
            if (idInput) idInput.value = variantId;
          }
        });
      });
    });
  }

  /* ── Thumbnail gallery (product page) ── */
  function initGallery() {
    document.querySelectorAll('.nt-thumb, .thumb').forEach(thumb => {
      thumb.addEventListener('click', function () {
        const gallery = this.closest('.gallery, .nt-gallery');
        if (!gallery) return;
        gallery.querySelectorAll('.nt-thumb, .thumb').forEach(t => t.classList.remove('active'));
        this.classList.add('active');
        const mainImg = gallery.querySelector('.nt-main-img img, .main-img img');
        if (mainImg && this.dataset.src) mainImg.src = this.dataset.src;
      });
    });
  }

  /* ── Scroll reveal ── */
  function initReveal() {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(el => obs.observe(el));
  }

  /* ── Ticker duplication (ensure seamless loop) ── */
  function initTicker() {
    const track = document.querySelector('.nt-ticker-track, .ticker-track');
    if (!track) return;
    const items = Array.from(track.children);
    if (items.length === 0) return;
    if (track.children.length < items.length * 2) {
      items.forEach(item => track.appendChild(item.cloneNode(true)));
    }
  }

  /* ── Header v2: transparent hero → dark glass on scroll ── */
  function initHeader() {
    const header = document.querySelector('.nt-hbar') || document.getElementById('ntHdOuter');
    if (!header) return;
    const main = document.getElementById('MainContent');
    if (!main || main.dataset.template !== 'index') return;

    function setHeaderHeight() {
      document.documentElement.style.setProperty('--nt-hbar-height', `${Math.round(header.offsetHeight)}px`);
    }

    function updateHeaderState() {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    }

    setHeaderHeight();
    updateHeaderState();
    window.addEventListener('resize', setHeaderHeight, { passive: true });
    window.addEventListener('scroll', updateHeaderState, { passive: true });
  }

  /* ── Mobile drawer ── */
  function initMobileDrawer() {
    const ham     = document.getElementById('ntHdHam');
    const drawer  = document.getElementById('ntHdDrawer');
    const close   = document.getElementById('ntHdDrawerClose');
    const bg      = document.getElementById('ntHdDrawerBg');
    if (!ham || !drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    ham.addEventListener('click', openDrawer);
    close && close.addEventListener('click', closeDrawer);
    bg && bg.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });
  }

  /* ── Search modal trigger ── */
  function initSearch() {
    const searchBtns = document.querySelectorAll('#ntHdSearch, .nt-hd-search-btn');
    const modal = document.getElementById('ntSearchModal');
    if (!modal) return;
    searchBtns.forEach(btn => {
      btn.addEventListener('click', () => modal.classList.add('open'));
    });
  }

  /* ── Cart button → open cart drawer (or fallback to cart page) ── */
  function initCartBtn() {
    const btn = document.getElementById('ntHdCart');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const drawer = document.getElementById('ntCartDrawer');
      if (drawer) {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        window.NataleeCartDrawer && window.NataleeCartDrawer.refresh();
      } else {
        window.location.href = '/cart';
      }
    });
  }

  /* ── Cat tile hover ── */
  function initCatTiles() {
    document.querySelectorAll('.nt-cat-tile, .cat-tile').forEach(tile => {
      const bg = tile.querySelector('.nt-cat-tile-bg, .cat-tile-bg');
      if (bg && bg.style.backgroundImage) {
        tile.addEventListener('mouseenter', () => bg.style.transform = 'scale(1.04)');
        tile.addEventListener('mouseleave', () => bg.style.transform = '');
      }
    });
  }

  /* ── Initialize ── */
  function init() {
    window.NataleeCart.getCount();
    initAddToCart();
    initCartQty();
    initSizeSelector();
    initGallery();
    initReveal();
    initTicker();
    initHeader();
    initMobileDrawer();
    initSearch();
    initCartBtn();
    initCatTiles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
